export class Score {
    homeScore: number;
    awayScore: number;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/score.model.ts